<template>
    <div
        dusk="ReaderModal"
        class="absolute right-0 top-0 z-9999 flex h-screen w-screen items-center justify-center overflow-auto bg-black/75"
    >
        <div
            ref="focusTrapContainer"
            role="dialog"
            aria-modal="true"
            :aria-label="ariaLabel"
            class="transition-height relative mx-auto w-full overflow-hidden rounded-xl bg-theme-bg pb-2 text-theme-text ring-1 ring-white/10 duration-150 ease-in-out"
            :class="{ 'pt-1': !headerAbsolute, 'px-2': headerAbsolute, 'max-w-96': !wide, 'max-w-5xl': wide }"
        >
            <div class="flex w-full flex-col items-center" :class="{ fixedHeight }">
                <div class="w-full" :class="{ absolute: headerAbsolute }">
                    <div class="flex w-full items-center" :class="{ 'pt-2': headerAbsolute }">
                        <slot name="header"></slot>
                        <BaseButton
                            dusk="ReaderModalClose"
                            icon="close"
                            :tooltip="localizations[lang].tooltips.close"
                            class="z-1000 ml-auto text-theme-toolbar-icon hover:text-theme-text"
                            :class="{ 'mr-4': !headerAbsolute, 'mr-2': headerAbsolute }"
                            @click="closeModal"
                        />
                    </div>
                </div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import BaseButton from '../Components/buttons/BaseButton.vue';
import focusTrapMixin from '../../js/mixins/focusTrapMixin';

export default {
    components: {
        BaseButton,
    },
    mixins: [focusTrapMixin],
    props: {
        headerAbsolute: {
            type: Boolean,
            default: false,
        },
        fixedHeight: {
            type: Boolean,
            default: true,
        },
        ariaLabel: {
            type: String,
            default: '',
        },
        /** For content that reads across, such as a table. */
        wide: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close-modal'],
    data() {
        return {
            focusTrapEnabled: true,
        };
    },
    computed: {
        ...mapState(['localizations', 'lang']),
    },
    methods: {
        onFocusTrapEscape() {
            this.closeModal();
        },
        closeModal() {
            this.focusTrapEnabled = false;
            this.$emit('close-modal', true);
        },
    },
};
</script>
